export default ['all', 'italia', 'europa', 'extraue']
